import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';

import { FALLBACK_LANGUAGES, SHIPPED_LANGUAGES } from './languages';

void i18next
  .use(ICU)
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // AgDR-0051 amendment: a regional tag (fr-CA) resolves to its language (fr); a language
    // that does not ship (de-DE while de has no files) or is off the list (ja) resolves to the
    // first fallback; a missing key reads through en, then fr.
    supportedLngs: SHIPPED_LANGUAGES,
    fallbackLng: FALLBACK_LANGUAGES,
    load: 'currentOnly',
    ns: ['common'],
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    backend: { loadPath: '/locales/{{lng}}/{{ns}}.json' },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

i18next.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
  document.documentElement.dir = ['ar', 'fa', 'he', 'ur'].some((rtl) => lng.startsWith(rtl))
    ? 'rtl'
    : 'ltr';
});

export const i18n = i18next;
